import React from 'react';
import { motion } from 'framer-motion';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const WorkoutPlansList = ({ plans, onEdit, onDelete, currentPlanId }) => {
  const difficultyColors = {
    beginner: 'text-green-600 bg-green-100',
    intermediate: 'text-yellow-600 bg-yellow-100',
    advanced: 'text-red-600 bg-red-100'
  };

  return (
    <div className="bg-card border border-border rounded-xl p-4">
      <div className="flex items-center gap-2 mb-4">
        <Icon name="FolderOpen" size={20} className="text-primary" />
        <h2 className="text-lg font-semibold text-foreground">Saved Plans</h2>
      </div>
      {plans?.length === 0 ? (
        <div className="text-center py-8">
          <Icon name="FolderOpen" size={32} className="mx-auto text-muted-foreground mb-2" />
          <p className="text-sm text-muted-foreground">No saved workout plans yet</p>
        </div>
      ) : (
        <div className="space-y-2 max-h-[400px] overflow-y-auto">
          {plans?.map((plan) => {
            const isActive = plan?.id === currentPlanId;
            return (
              <motion.div
                key={plan?.id}
                className={`p-3 rounded-lg border transition-all ${
                  isActive
                    ? 'bg-primary/10 border-primary' :'bg-muted border-border hover:border-primary/50'
                }`}
                whileHover={{ scale: 1.02 }}
              >
                <div className="flex items-start justify-between gap-2 mb-2">
                  <div className="flex-1 min-w-0">
                    <h3 className="text-sm font-semibold text-foreground truncate">{plan?.name}</h3>
                    <div className="flex items-center gap-2 mt-1">
                      <span className={`text-xs px-2 py-0.5 rounded-full ${difficultyColors?.[plan?.difficulty]}`}>
                        {plan?.difficulty}
                      </span>
                      <span className="text-xs text-muted-foreground">
                        {plan?.durationMinutes} min
                      </span>
                    </div>
                  </div>
                  {isActive && (
                    <div className="flex items-center gap-1 text-xs text-primary">
                      <Icon name="Edit" size={12} />
                      <span>Editing</span>
                    </div>
                  )}
                </div>
                {plan?.workoutPlanExercises?.length > 0 && (
                  <p className="text-xs text-muted-foreground mb-2">
                    {plan?.workoutPlanExercises?.length} exercises
                  </p>
                )}
                <div className="flex gap-2">
                  <Button
                    size="sm"
                    variant="outline"
                    onClick={() => onEdit(plan)}
                    fullWidth
                    disabled={isActive}
                  >
                    <Icon name="Edit" size={14} className="mr-1" />
                    Edit
                  </Button>
                  <Button
                    size="sm"
                    variant="outline"
                    onClick={() => onDelete(plan)}
                    className="text-destructive hover:text-destructive"
                  >
                    <Icon name="Trash2" size={14} />
                  </Button>
                </div>
              </motion.div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default WorkoutPlansList;